<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div class="jm margem" @click.stop style="min-width: 50vw;">
            <div class="modal-header">
                <h3>{{ grupoParaEditar ? 'Editar Grupo' : 'Adicionar Grupo' }}</h3>
            </div>
            <div class="grid-2">
                <div>
                    <label>Nome do Grupo</label>
                    <input v-model="nome" type="text">
                </div>
                <div>
                    <label>Fim Previsto</label>
                    <input v-model="dtFimPrevisto" type="date">
                </div>
                <div class="col-2">
                    <label>Participantes para adicionar</label>
                    <input v-model="searchQueryUser" @focus="listaAbertaUser = true" @blur="fecharListaUser"
                        placeholder="Pesquisar Usuário" type="text" style="width: 100%;" />
                    <div v-if="listaAbertaUser" class="dropdown-list" style="cursor: pointer;">
                        <ul>
                            <li v-for="user in filteredUsers" :key="user.id" style="margin:5px">
                                <div @click="toggleUser(user)"
                                    style="padding: .5rem 1rem; border: 1px solid var(--cor-separador); border-radius: 12px"
                                    :class="{ 'disabled': isUserInGroup(user) }">
                                    {{ user.nomeCompleto }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="selected-users col-2">
                    <label>Participantes: </label>
                    <div class="tags">
                        <a v-for="(user, index) in participantesSelecionados" :key="user.id || index">
                            {{ user.nomeCompleto ?? user.nome }}
                            <i v-if="user.id !== idUsuario" class="fa-solid fa-circle-xmark"
                                @click="desassociarUsuario(user)" style="color: red; margin-left: 10px;"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="submit">
                    <button @click="confirmar">{{ grupoParaEditar ? 'Salvar' : 'Criar' }}</button>
                    <button @click="$emit('fechar')" class="acao-secundaria">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalAdicionarGrupo",

    props: {
        mostrar: { type: Boolean, default: false },
        usuarios: { type: Array, default: () => [] },
        idUsuario: { type: [Number, String], required: true },
        grupoParaEditar: { type: Object, default: null },
    },

    emits: ["fechar", "criar", "salvarEdicao"],

    data() {
        return {
            nome: null,
            dtFimPrevisto: null,
            participantesSelecionados: [],
            searchQueryUser: "",
            listaAbertaUser: false,
        };
    },

    computed: {
        filteredUsers() {
            if (!this.searchQueryUser) return this.usuarios.slice(0, 20);
            return this.usuarios.filter((user) =>
                (user.nomeCompleto || "").toLowerCase().includes(this.searchQueryUser.toLowerCase())
            );
        },
    },

    watch: {
        mostrar(visivel) {
            if (visivel) {
                this.inicializarForm();
            }
        },
        grupoParaEditar: {
            handler(grupo) {
                if (grupo && this.mostrar) this.inicializarForm();
            },
            deep: true,
        },
    },

    methods: {
        inicializarForm() {
            if (this.grupoParaEditar) {
                this.nome = this.grupoParaEditar.nome;
                this.participantesSelecionados = [...(this.grupoParaEditar.participantes || [])];
                this.dtFimPrevisto = this.grupoParaEditar.dtFimPrevisto || null;
            } else {
                this.nome = null;
                this.dtFimPrevisto = null;
                const usuarioLogado = this.usuarios.find((u) => Number(u.id) === Number(this.idUsuario));
                this.participantesSelecionados = usuarioLogado ? [usuarioLogado] : [];
            }
            this.searchQueryUser = "";
            this.listaAbertaUser = false;
        },
        fecharListaUser() {
            setTimeout(() => {
                this.listaAbertaUser = false;
            }, 200);
        },
        toggleUser(user) {
            if (!this.isUserInGroup(user)) {
                this.participantesSelecionados.push(user);
            }
            this.searchQueryUser = "";
        },
        isUserInGroup(user) {
            return this.participantesSelecionados.some((p) => Number(p.id) === Number(user.id));
        },
        desassociarUsuario(user) {
            this.participantesSelecionados = this.participantesSelecionados.filter(
                (p) => Number(p.id) !== Number(user.id)
            );
        },
        confirmar() {
            const payload = {
                nome: this.nome,
                participantes: this.participantesSelecionados.map((item) => item.id),
            };
            if (this.grupoParaEditar) {
                this.$emit("salvarEdicao", { id: this.grupoParaEditar.id, ...payload });
            } else {
                this.$emit("criar", {
                    ...payload,
                    dtFimPrevisto: this.dtFimPrevisto,
                });
            }
        },
    },
};
</script>

<style scoped>
.jm {
    min-width: 30rem;
}

.dropdown-list {
    background-color: var(--cor-bg);
    z-index: 99999;
    max-height: 20rem;
    overflow: auto;
    position: absolute;
    width: 20.5rem;
    border: 1px solid var(--cor-separador);
}
</style>
